/**
 * Logger condicional — logs só aparecem quando o modo debug está ativo.
 * Para ativar no browser: `ctDebug.on()` no console, depois recarregue a página.
 * Erros são sempre exibidos, independente do modo debug.
 */
import * as Sentry from '@sentry/react'

const isDebug = () => localStorage.getItem('ct_debug') === 'true'

export const logger = {
  log:   (...args: unknown[]) => isDebug() && console.log('[CT]', ...args),
  warn:  (...args: unknown[]) => isDebug() && console.warn('[CT]', ...args),
  error: (...args: unknown[]) => console.error('[CT ERROR]', ...args),
}

/** Reporta erro ao Sentry e retorna mensagem amigável para exibir na UI. */
export function captureError(err: unknown, context?: string): string {
  console.error('[CT ERROR]', context ?? '', err)
  Sentry.captureException(err, context ? { extra: { context } } : undefined)
  if (err instanceof Error) return err.message
  return 'Erro inesperado. Tente novamente.'
}

// Expõe utilitário de diagnóstico na janela do browser — nunca usado em produção programaticamente
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).ctDebug = {
    on:     () => { localStorage.setItem('ct_debug', 'true'); location.reload() },
    off:    () => { localStorage.removeItem('ct_debug'); location.reload() },
    status: () => console.log('Debug:', isDebug() ? 'ATIVO' : 'desativado'),
  }
}
